import React, { useContext } from 'react'
import AppContext from 'context'
import CashflowSection from 'components/form/cashflow/cashflow-section'
import AssetSection from 'components/form/assets/asset-section'
import EndMessage from 'components/form/end-msg'
import WP_DATA from 'utils/wp_data'

const isCashflowType = WP_DATA.worksheet_type === 'cashflow-analysis'

export default () => {
  const { state } = useContext(AppContext)
  if (state.view === 'END') {
    return <EndMessage />
  } else if (state.view !== '') {
    const [key, data] = Object.entries(state.worksheet_data)
      .find(s => {
        const [k] = s
        return k === state.view ? s : false
      })
    return isCashflowType
      ? <CashflowSection sectionId={state.view} id={key} data={data} />
      : <AssetSection sectionId={state.view} id={key} data={data} />
  }
  return null;
}